// extracted by mini-css-extract-plugin
module.exports = {"content":"DialogCard_content__DrNgR"};